import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { BLOCKS, INLINES } from "@contentful/rich-text-types"
import React from "react"
import "./article-generic.scss"

import ArticleAudio from "../article-audio/article-audio"


const ArticleGeneric = props => {
  const { slugPrefix } = props
  const LOCALE = process.env.LOCALE ? process.env.LOCALE : "es-CO"
  const arrayVideosLink = [
    "https://jwp.io",
    "https://videos.ctfassets.net",
    "youtube",
    "youtu.be",
  ]

  let options = {
    renderNode: {
      // [BLOCKS.HEADING_1]: (node, next) => <h1 className={`f-${slug}`}>{next}</h1>,
      [BLOCKS.EMBEDDED_ASSET]: (node, next) => (
        <img
          className="f-aticle-content-img"
          src={
            node.data.target.fields.file[LOCALE]
              ? node.data.target.fields.file[LOCALE].url
              : node.data.target.fields.file["es-CO"].url
          }
          alt={node.data.target.fields.description[LOCALE]}
        />
      ),
      [BLOCKS.EMBEDDED_ASSET]: (node, next) => {
        if (node.data.target.fields) {
          return (
            <img
              className="f-aticle-content-img"
              src={
                node.data.target.fields.file[LOCALE]
                  ? node.data.target.fields.file[LOCALE].url
                  : node.data.target.fields.file["es-CO"].url
              }
              alt={node.data.target.fields.description[LOCALE]}
            />
          )
        } else {
          return null
        }
      },
      [INLINES.HYPERLINK]: (node, next) => {
        return next[0].toString().toLowerCase() === "video" ? (
          <iframe
            className="f-article-video-nosotras"
            frameBorder="0"
            sandbox="allow-popups allow-same-origin allow-scripts"
            scrolling="no"
            src={
              node.data.uri.includes("youtube")
                ? node.data.uri.replace("watch?v=", "embed/")
                : node.data.uri.includes("youtu.be")
                  ? node.data.uri.replace(".be/", "be.com/embed/")
                  : node.data.uri
            }
            allowFullScreen={true}
            webkitallowfullscreen="true"
            mozallowfullscreen="true"
            sandbox="allow-forms allow-scripts allow-same-origin"
            allow="microphone; camera; fullscreen"
          />
        ) : (
          <a href={node.data.uri} rel="noopener noreferrer" target="_blank">
            {next}
          </a>
        )
      },
    },
  }

  return (
    <div className="f-article-body">

      <ArticleAudio audioContent={props} />

      {/* <span className="f-box-mobile" dangerouslySetInnerHTML={{ __html: props.contentArticle.childContentfulRichText.html }}></span> */}

      {/* {divided.map((fragment,index) => {
                return (
                    <span className="f-box-mobile" key={index}>
                        <span dangerouslySetInnerHTML={{ __html: fragment }}></span>
                        {props.images !== null && (index <= props.images.length - 1) && (divided.length !== 1) &&
                            <img 
                                className="f-aticle-content-img"
                                src={props.images[index].file.url}
                                alt={props.images[index].description}
                            /> 
                        }
                    </span>

                )
            })} */}
      {props.contentArticle !== null && (
        <span className="f-box-mobile">
          {documentToReactComponents(props.contentArticle.json, options)}
        </span>
      )}

      <div className="f-page-buttons-container">
        {props.prevPag !== null && (
          <a href={slugPrefix + props.prevPag.slug}>
            <div className="f-option f-prev-option">
              <span className="f-text-action">Anterior artículo</span>

              <div className="f-icon-action-container f-container-icon-left">
                <span className="f-icon icon-right f-icon-left" />
              </div>
            </div>
          </a>
        )}
        {props.nextPag !== null && (
          <a href={slugPrefix + props.nextPag.slug}>
            <div className="f-option f-next-option">
              <div className="f-icon-action-container ">
                <span className="f-icon icon-right f-icon-right" />
              </div>
              <span className="f-text-action">Siguiente artículo</span>
            </div>
          </a>
        )}
      </div>
    </div>
  )
}

export default ArticleGeneric
